export const musicCollection_8182 = {
    "@type": "Context",
    "id": 8182,
    "title": "Indie Pop",
    "description": "04",
    "lastChanged": null,
    "changeableParameter": [
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Music Feel",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Music Feel",
            "value": [
                {
                    "value": "Electronic",
                    "selected": false
                },
                {
                    "value": "Folk",
                    "selected": false
                },
                {
                    "value": "Pop",
                    "selected": true
                },
                {
                    "value": "Rock",
                    "selected": true
                },
                {
                    "value": "Soul",
                    "selected": true
                }
            ]
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "year",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "year",
            "minimum": 1980,
            "maximum": 2019,
            "step": 1,
            "lowerSelection": 1980,
            "upperSelection": 2019,
            "metadataDisplayMinimum": "-",
            "metadataDisplayMaximum": "+"
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "Region Popularity",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Region Popularity",
            "minimum": 4,
            "maximum": 6,
            "step": 1,
            "lowerSelection": 5,
            "upperSelection": 6,
            "metadataDisplayMinimum": "4",
            "metadataDisplayMaximum": "6"
        },
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Mood",
            "metadataDisplayType": "TEXT_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Mood",
            "value": [
                {
                    "value": "Peaceful",
                    "selected": true
                },
                {
                    "value": "Social",
                    "selected": true
                },
                {
                    "value": "Bright",
                    "selected": true
                },
                {
                    "value": "Dynamic",
                    "selected": true
                }
            ]
        }
    ],
    "defaultChangeableParameter": [
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Music Feel",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Music Feel",
            "value": [
                {
                    "value": "Electronic",
                    "selected": false
                },
                {
                    "value": "Folk",
                    "selected": false
                },
                {
                    "value": "Pop",
                    "selected": true
                },
                {
                    "value": "Rock",
                    "selected": true
                },
                {
                    "value": "Soul",
                    "selected": true
                }
            ]
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "year",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "year",
            "minimum": 1980,
            "maximum": 2019,
            "step": 1,
            "lowerSelection": 1980,
            "upperSelection": 2019,
            "metadataDisplayMinimum": "-",
            "metadataDisplayMaximum": "+"
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "Region Popularity",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Region Popularity",
            "minimum": 4,
            "maximum": 6,
            "step": 1,
            "lowerSelection": 5,
            "upperSelection": 6,
            "metadataDisplayMinimum": "4",
            "metadataDisplayMaximum": "6"
        },
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Mood",
            "metadataDisplayType": "TEXT_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Mood",
            "value": [
                {
                    "value": "Peaceful",
                    "selected": false
                },
                {
                    "value": "Social",
                    "selected": true
                },
                {
                    "value": "Bright",
                    "selected": true
                },
                {
                    "value": "Dynamic",
                    "selected": false
                }
            ]
        }
    ],
    "visible": true,
    "editable": false,
    "favourite": false,
    "selected": false,
    "mostPlayed": false,
    "defaultSelected": false
};